import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import InputEmailVerificationCode from './InputPages/InputEmailVerificationCode'
import InputEmail from './InputPages/InputEmail'
import { getUrlParamValue } from 'shared/helpers/UrlHelper'
import * as api from 'Authorization/api/emailVerification'
import { useTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS } from 'shared/customHooks'

import './style.css.scss'

const EmailVerificationContainer = (props) => {
  const { getTranslation } = useTranslation(TRANSLATION_KEYS.twoFAPage, props.locale)

  const [email, setEmail] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')
  const [emailSender, setEmailSender] = useState('')

  const authId = useSelector(({ authorization }) => authorization.authId)

  useEffect(() => {
    authId && api.getEmailVerificationInfo(authId).then((response) => {
      setEmailSender(response.verification_email_sender)
    })
    const error = getUrlParamValue(window.location.href, 'error')
    if (error) {
      setErrorMessage(error)
    }
  }, [authId])

  const handleEmailConfirm = (email) => {
    return api.sendEmailVerification(authId, email)
      .then(() => {
        setErrorMessage('')
        setEmail(email)
      })
      .catch(error => {
        if (error.response.status === 403) {
          setErrorMessage(getTranslation(TRANSLATION_VALUE_KEYS.emailNotAuthorized))
        } else {
          setErrorMessage(getTranslation(TRANSLATION_VALUE_KEYS.errorOccurred))
        }
      })
  }

  const handleCodeConfirm = (code) => {
    setErrorMessage('')
    api.verifyEmailCode(authId, code)
      .then(data => {
        const redirectUrl = data.redirect_to + document.location.hash
        window.location.replace(redirectUrl)
      }
      )
      .catch(error => {
        if (error.response.status === 400) {
          setErrorMessage(getTranslation(TRANSLATION_VALUE_KEYS.incorrectCode))
        } else {
          setErrorMessage(getTranslation(TRANSLATION_VALUE_KEYS.errorOccurred))
        }
      })
  }

  const handleResendCode = () => {
    return handleEmailConfirm(email)
  }

  return (
    <>
      { email
        ? <InputEmailVerificationCode
            onCodeConfirm={handleCodeConfirm}
            errorMessage={errorMessage}
            onResendCode={handleResendCode}
            locale={props.locale}
            emailSender={emailSender}
            pageProperties={props.pageProperties} />
        : <InputEmail
            onEmailConfirm={handleEmailConfirm}
            errorMessage={errorMessage}
            locale={props.locale}
            privacyMessage={props.privacyMessage}
            pageProperties={props.pageProperties} />
      }
    </>
  )
}

EmailVerificationContainer.propTypes = {
  privacyMessage: PropTypes.object,
  locale: PropTypes.string.isRequired,
  pageProperties: PropTypes.object.isRequired
}

export default EmailVerificationContainer
